import {Component, ViewEncapsulation} from '@angular/core';
import {NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';

@Component({
  selector: 'app-document-continue',
  templateUrl: './document-continue.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DocumentContinueComponent {

  constructor(public nav: NavigateService, public cart: CartService) {}

  clickStop() {
    this.cart.removeStorageOLD();
    this.nav.to('document-management');
  }
}
